import React, { useEffect } from "react";

const DashboardContainer = ({ children }) => {
  return (
    <>
      <section className="py-10 dark:bg-jacarta-800">
        <div>{children}</div>
      </section>
    </>
  );
};

export default DashboardContainer;
